export enum CalendarFilterVariants {
  IS_PRIMARY_CALENDAR_FILTER = 'is_primary_calendar_filter',
  IS_SECONDARY_CALENDAR_FILTER = 'is_secondary_calendar_filter',
}

const TOURS_FLAGS = {
  TOURS_CHEAPER_HOTEL_OFFERS: 'trfree_cheaper_hotel_offers',
  TOURS_NEW_CASHBACK_DESIGN: 'trfree_new_cashback_design',
  TOURS_OFFER_IMAGE_FORMAT: 'trfree_offers_image_format',
  TOURS_COMPLEX_ROUTES: 'trfree_complex_routes',
  TOURS_ONBOARDING_FULLSCREEN: 'trfree_onboarding_fullscreen',
  TOURS_BEST_SELLERS: 'trfree_best_sellers',
  TOURS_MAIN_PAGE_HOT_TOURS: 'trfree_main_page_hot_tours',
  TOURS_TRAVEL_SALE_PROMO: 'trfree_travel_sale_promo',
  TOURS_SIMILAR_HOTELS: 'trfree_similar_hotels',
};

const AVIA_FLAGS = {
  FARE_FAMILIES_FLEXIBLE: 'avfree_fare_families_flexible',
  CALENDAR_FILTER: 'calendar_filter',
  NEW_BOTTOM_NAV: 'avfree_new_bottom_nav',
  AVIA_FAVORITES_PAGE: 'avfree_favorites_page',
  SPECIAL_OFFER_FRIENDS: 'avfree_special_offer_friends',
  AI_CHAT_ENABLED: 'avfree_ai_chat_enabled',
  AI_CHAT_TICKETON_OPEN_METHOD: 'avfree_ai_chat_ticketon_open_method',
  POST_BOOKING_CROSS_SELL: 'cabfree_post_booking_cross_sell',
  MAIN_PAGE_REDESIGN: 'avfree_main_page_redesign',
  QUICK_BOOKING_OW_SINGLE_PAX: 'avfree_quick_booking_ow_single_pax',
  /** A/B: control = old per-field bottom sheets, animated = new unified flow sheet (simple mode only) */
  SEARCH_FORM_ANIMATED_FLOW: 'avfree_search_form_animated_flow',
  /** A/B: off (control) = no recommended-offers block on main page, on = block visible. Treatment variant key: `avfree_recommended_offers_on`. */
  RECOMMENDED_OFFERS: 'avfree_recommended_offers',
};

export const experimentsFlags = {
  ...AVIA_FLAGS,
  ...TOURS_FLAGS,
};

/**
 * Experiments that are shared across apps and should be cached in localStorage.
 * Only these experiments will persist their variant between app navigations.
 * This prevents UI flicker when the Amplitude SDK returns stale cached results
 * from a different app (e.g. railways with a different user ID).
 */
export const CROSS_APP_CACHED_EXPERIMENTS: ReadonlySet<string> = new Set([
  AVIA_FLAGS.NEW_BOTTOM_NAV,
]);
